<template>
  <div id="audienceEntry" class="f-s-c w-100 h-100">
    <div class="content f-s-c w-100 h-100">
      <div class="right f-c-s f-d-c w-50 h-100">
        <div class="up f-c-c w-100">
          <b-img
          style="width: 100px"
            :src="require(`@/assets/images/audienceEntry/logo-vadagap-one.svg`)"
          ></b-img>
        </div>
        <div class="down f-c-c w-100">
          <div class="loginBox f-c-c f-d-c w-100 h-100">
            <div v-if="tabStatus == 1" class="fieldes f-c-s f-d-c w-100">
              <b-img
                :src="require(`@/assets/images/audienceEntry/error-404.svg`)"
              ></b-img>
              <div class="text f-c-c w-100">جلسه یافت نشد.</div>
            </div>
            <div v-else class="fieldes f-c-s f-d-c w-100">
              <b-img
                :src="require(`@/assets/images/audienceEntry/stop.svg`)"
              ></b-img>
              <div class="text f-c-c w-100">
                در حال حاضر دسترسی به جلسه امکان پذیر نیست.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left w-50 h-100">
        <b-img :src="require(`@/assets/images/audienceEntry/half.png`)"></b-img>
      </div>
    </div>
    <div class="gapMaterial gapMaterialAudienceEntry f-c-c w-100">
      <div class="text f-c-c">
        کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
        باشد.
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "404",
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      tabStatus: (state) => state.gap.tabStatus,
    }),
  },
  components: {},
  methods: {},
  watch: {
    tabStatus() {},
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
#audienceEntry {
  background-color: #8EBBDF;
  padding: 4%;
  .content {
    .right {
      background-color: white;
      border-radius: 0 30px 30px 0;
      padding: 1% 5%;
      overflow: auto;
      .up {
        height: 30%;
      }
      .down {
        height: 60%;
        .loginBox {
          background-color: #EDF7FF;
          border-radius: 10px;
          padding: 5%;
          .fieldes {
            img {
              width: 20%;
              margin-bottom: 5%;
            }
            .text {
              font-size: 85%;
              color: #125488;
            }
          }
        }
      }
    }
    .left {
      img {
        width: 100%;
        height: 100%;
        border-radius: 30px 0 0 30px;
      }
      border-radius: 30px 0 0 30px;
    }
  }
}
</style>